<app-input-field
  [formControl]="control()"
  [label]="'app.components.profileSettings.languageLabel' | translate"
  inputType="select"
  [options]="options()"
  [selectedValue]="control().value"
></app-input-field>
